import { render, staticRenderFns } from "./CoachOnboarding.vue?vue&type=template&id=163ff13e&"
import script from "./CoachOnboarding.vue?vue&type=script&lang=ts&"
export * from "./CoachOnboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports